import React  from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { hideMainDialog } from '../../actions/mainUI';
import {
  MODAL_VIEW_TYPE_SHARE,
} from '../../constants/mainContentTypes';
import UMOShareLinkView from '../UMOShareLinkView';

const mapStateToProps = state => ({
  mainUI: state.mainUI,
});

const mapDispatchToProps = dispatch => ({
  hideDialog: () => dispatch(hideMainDialog()),
});

const MainDialogModal = ({ mainUI, hideDialog }) => {
  const viewType = mainUI.get('dialogView');
  let modalBody;
  switch (viewType) {
    case (MODAL_VIEW_TYPE_SHARE):
      modalBody =
        <UMOShareLinkView data={mainUI.get('dialogData')} />;
      break;
    default:
      break;
  }
  return (
    <div className="message-dialog">
      <Modal
        show={!!viewType}
        dialogClassName={cn('message-dialog__overlay',
          { 'message-dialog__overlay--edit': true },
          viewType === MODAL_VIEW_TYPE_SHARE && 'message-dialog__share-view',
        )}
        onHide={hideDialog}
      >
        <button
          onClick={hideDialog}
          className="message-dialog__close-button"
        />

        <div className="message-dialog__body">
          {modalBody}
        </div>
      </Modal>
    </div>
  );
};

MainDialogModal.propTypes = {
  mainUI: PropTypes.instanceOf(Map),
  hideDialog: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MainDialogModal));



// WEBPACK FOOTER //
// ./src/js/components/MainDialogModal/index.jsx